import { useWizard } from "./wizardStore";
import { Modal } from "../../ui/Modal";

// A blocking note the tour shows instead of the step card. OK clears it and the host
// returns to the step that was underneath.
export function WizardNotice({ notice }: { notice: string }) {
  return (
    <Modal>
      <div
        className="fixed inset-0 z-top flex items-center justify-center bg-black/40"
        data-testid="wizard-notice"
      >
        <div className="w-80 rounded-lg border border-line bg-surface p-4 shadow-2xl">
          <p className="text-sm text-fg">{notice}</p>
          <div className="mt-3 text-right">
            <button
              onClick={() => useWizard.getState().setNotice(null)}
              className="rounded bg-accent px-3 py-1 text-xs font-medium text-canvas hover:bg-accent-hover"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
